import React, { createContext, useContext } from "react";

const HistoryContext = createContext();

export function HistoryProvider({ children }) {
  const logHistory = async ({
    antibodyId,
    adminName,
    changes = [],
    action,
    email
  }) => {
    if (!antibodyId) return;

    try {
      // If we have structured changes array, log each field separately
      if (changes && changes.length > 0) {
        for (const change of changes) {
          // Parse "fieldName changed from "oldVal" to "newVal""
          const match = change.match(/^(.+) changed from "(.*)?" to "(.*)"$/);
          if (match) {
            const [, field, oldValue, newValue] = match;
            await fetch(`https://dshb-deposits.its.uiowa.edu/api/log-history`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                submission_id: antibodyId,
                admin_name: adminName || email || "Admin",
                action: change,
                field_name: field,
                old_value: oldValue,
                new_value: newValue
              }),
            });
          }
        }
      } else if (action) {
        // Simple action log (email sent, generated, synced etc)
        await fetch(`https://dshb-deposits.its.uiowa.edu/api/log-history`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            submission_id: antibodyId,
            admin_name: adminName || email || "Admin",
            action: action,
            field_name: null,
            old_value: null,
            new_value: null
          }),
        });
      }
    } catch (err) {
      console.error("Failed to log history:", err);
    }
  };

  return (
    <HistoryContext.Provider value={{ logHistory }}>
      {children}
    </HistoryContext.Provider>
  );
}

export function useHistoryLogger() {
  return useContext(HistoryContext);
}